import {NextRouter} from 'next/router'
import {parse} from 'querystring'

export default function getQueryObject(router: NextRouter) {
  const queryString = router.asPath.split('?')[1] ?? ''
  return parse(queryString)
}
